export const HOME = {
    emergentLink: "emergent-link",
    heroBookWhatsapp: "hero-book-whatsapp-btn",
    heroCallNow: "hero-call-now-btn",
    heroGetQuote: "hero-get-quote-btn",
};

export const NAV = {
    container: "site-header",
    logo: "site-logo",
    linkHome: "nav-link-home",
    linkFleet: "nav-link-fleet",
    linkServices: "nav-link-services",
    linkAbout: "nav-link-about",
    linkContact: "nav-link-contact",
    ctaCall: "nav-cta-call",
    ctaWhatsapp: "nav-cta-whatsapp",
    mobileToggle: "nav-mobile-toggle",
    mobileMenu: "nav-mobile-menu",
};

export const FLOATING = {
    whatsapp: "floating-whatsapp-btn",
    call: "floating-call-btn",
};

export const BOOKING_FORM = {
    root: "booking-form",
    name: "booking-form-name",
    mobile: "booking-form-mobile",
    pickup: "booking-form-pickup",
    drop: "booking-form-drop",
    date: "booking-form-date",
    vehicle: "booking-form-vehicle",
    service: "booking-form-service",
    message: "booking-form-message",
    submit: "booking-form-submit",
};

export const QUOTE_DIALOG = {
    trigger: "instant-quote-trigger",
    root: "instant-quote-dialog",
    name: "quote-form-name",
    mobile: "quote-form-mobile",
    pickup: "quote-form-pickup",
    drop: "quote-form-drop",
    vehicle: "quote-form-vehicle",
    date: "quote-form-date",
    submit: "quote-form-submit",
};

export const CONTACT_FORM = {
    root: "contact-form",
    name: "contact-form-name",
    email: "contact-form-email",
    mobile: "contact-form-mobile",
    subject: "contact-form-subject",
    message: "contact-form-message",
    submit: "contact-form-submit",
};

export const FLEET = {
    card: (slug) => `fleet-card-${slug}`,
    bookBtn: (slug) => `fleet-book-${slug}`,
    quoteBtn: (slug) => `fleet-quote-${slug}`,
};

export const FAQ = {
    item: (i) => `faq-item-${i}`,
};

export const REVIEW = {
    card: (i) => `review-card-${i}`,
};
